import React from 'react';
import './Blogs.css';
import mySql from '../../images/sql_image.png';
import routerV6 from '../../images/react_router.jpg';
import dom from '../../images/virtual_dom.png';
import Zoom from 'react-reveal/Zoom';

import Rotate from 'react-reveal/Rotate';

const Blogs = () => {
    return (
        <div className='blogs__section'>
            <Zoom duration={2000}>
                <div className='single__blog' >
                    <div className='blog__img'>
                        <img src={mySql} alt="mySQL banner" />
                    </div>
                    <div className='blog__text'>
                        <h4>Simple overview of MySQL (The  Relational Database)</h4>
                        <a href="https://dev.to/naimeahmed/simple-overview-of-mysql-relational-database-3nk7" target="_blank" rel="noopener noreferrer">see details</a>
                    </div>
                </div>
            </Zoom>
            <Rotate duration={3000}>
                <div className='single__blog' >
                    <div className='blog__img'>
                        <img src={routerV6} alt="react router dom V6" />
                    </div>
                    <div className='blog__text'>
                        <h4>What's new changes and features in React Router v6.</h4>
                        <a href="https://dev.to/naimeahmed/whats-new-changes-and-features-in-react-router-v6-1o0c" target="_blank" rel="noopener noreferrer">see details</a>
                    </div>
                </div>
            </Rotate>
            <Zoom duration={2000}>
                <div className='single__blog'>
                    <div className='blog__img'>
                        <img src={dom} alt="virtual DOM banner" />
                    </div>
                    <div className='blog__text'>
                        <h4>How React Virtual DOM work. Why it's so efficient for building web app</h4>
                        <p>Coming soon</p>
                    </div>
                </div>
            </Zoom>
        </div>
    );
};

export default Blogs;